import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "@firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyAidbb5kT2zc-JmebcYjo3OgBq0Id7UhyE",
    authDomain: "task-management-3a546.firebaseapp.com",
    projectId: "task-management-3a546",
    storageBucket: "task-management-3a546.appspot.com",
    messagingSenderId: "764797945440",
    appId: "1:764797945440:web:28115c705acbc093102505",
    measurementId: "G-4EYG7VWCFQ",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);

export const db = getFirestore(app);
